$(document).ready(function() {
  setTimeout(function() {
    $(".pro_slider").css({opacity: 0, visibility: "visible"}).animate({opacity: 1}, 200);
    $(".pro_slider").slick('slickGoTo', 0);
  },10);
  $('.pro_slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,   
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }, {
      breakpoint: 768,
      settings: {
        dots: true
      }
    }, {
      breakpoint: 480,
      settings: {
        dots: true
      }
    }]
  });

  $('.slider_12').slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,   
    slidesToShow: 1,
    slidesToScroll: 1
  });
  $('.fea_main').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,   
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(".find_slider").slick({
    dots: true,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    autoplay:false,
    slidesToScroll: 1,
  });
});	

jQuery(document).ready(function(){
  $(".menu_div").click(function(){
    $(".toplmenu").hide();
    $(".toplmenu1").show();
    $(".mobilemenu").css('left','0px');
    $(".mobilemenu").fadeIn(500);
  });
  $(".menu_icn").click(function(){
    $(".toplmenu").show();
    $(".toplmenu1").hide();
    $(".mobilemenu").fadeOut(600);
  });
});

function showm() {    
  $('.menu1').slideToggle('medium');  
} 

function cpop() {    
  $('.cpopup').fadeIn();  
  $('.cpopup').css({'display': 'flex'});
  $('body').css({'overflow': 'hidden'});
}
function closep() {
  $('.cpopup').fadeOut();         
  $('body').css({'overflow': 'visible'});
} 

function showcart(para) {
  if(para==1) {
    $(".drawer").show('slow');
    $(".drawer").css('right','0px');
  }
  if(para==2) {
    $(".drawer").hide();
    $(".drawer").css('right','-450px');
  }

  $(".mobilemenu").hide(); 
}


jQuery(function() {
  $('#colsw').text($('#firstswatch').text());

  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');   

    $('#colsw').text(optionValue);
  });
});  

/**
function getswval(para, ids, flid, type) {        
  //alert(ids);
  if(type=="Color") {
    $('#procol'+ids).val(para);

    var sizcol = $('#procol'+ids).val();

    var sizei = $('#prosel'+ids).find("option:contains("+sizcol.toString()+")").val();

    if($('#sh'+ids+' #'+sizei).length == 0) {     	
    } else {
      $('#sh'+ids+' .proimg').hide();
      $('#sh'+ids+' #'+sizei).show();

      $('#colo'+ids+' .swlabel').removeClass('active');
      $('#col'+flid+ids).addClass('active');
    }
  } 
}  
*/

function showfit(para) {
  if(para==1) {
    $(".find_my_fit_top").show('slow');
    $(".find_my_fit_top").css('right','0px');        
  }
  if(para==2) {
    $(".find_my_fit_top").hide();
    $(".find_my_fit_top").css('right','-450px');
    $("#find2").hide();
    $("#find3").hide();
    $("#find4").hide();
    $("#find5").hide();
    $("#find1").show();
  }
  if(para==3) {
    $("#find1").hide();
    $("#find2").show('slow');
    $("#find2").css('right','-450px');
  }  
  if(para==4) {
    $("#find1").show('slow');
    $("#find2").hide();
  }   
  if(para==5) {
    $("#find3").show('slow');
    $("#find2").hide();
  } 
  if(para==6) {
    $("#find2").show('slow');
    $("#find3").hide();
  }   
  if(para==7) {
    $("#find4").show('slow');
    $("#find3").hide();
  }   
  if(para==8) {
    $("#find4").hide();
    $("#find3").show('slow');
  }  
  if(para==9) {
    $("#find4").hide();
    $("#find5").show('slow');
  }    
  if(para==10) {
    $("#find5").hide();
    $("#find4").show('slow');
  }      

  $(".mobilemenu").hide(); 
}

$(document).ready(function() {
  var dialogShown = localStorage.getItem('dialogShown')

  if (!dialogShown) {
    $(".announcement-bar").show();
  }
  else {
    $(".announcement-bar").hide();
  }
});

function cloasenot() {  
  $('.announcement-bar').fadeOut();
  localStorage.setItem('dialogShown', 1);  
}